/* eslint-disable */
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  Input,
  Text,
  Textarea,
  Select,
  Flex,
  useToast,
  Switch,
  Checkbox,
  CheckboxGroup,
  Stack,
  useColorModeValue
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { DEPARTMENTS } from "../../constants/departments";

import AdminNavTop from "../AdminNavTop";
import { useDispatch, useSelector } from "react-redux";
import { addProduct } from "../../Redux/AdminReducer/action";
import { useNavigate } from "react-router-dom";
import { useModalToast } from "../../context/GlobalModalToast";

const AddCourse = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { toast } = useModalToast();

  let obj = {
    title: "",
    description: "",
    category: "",
    department: "",
    img:"",
    teacher: "",
    teacherId: "",
    isGlobal: true,
    targetSectors: [],
    allowComments: true
  };

  const [detail, setDetail] = useState(obj);
  const [categories, setCategories] = useState([]);
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [customCategory, setCustomCategory] = useState("");
  const [teachers, setTeachers] = useState([]);
  const [uploadType, setUploadType] = useState("link"); // 'link' or 'file'

  useEffect(() => {
    fetchCategories();
    fetchTeachers();
  }, []);

  const fetchTeachers = async () => {
    try {
      const token = JSON.parse(localStorage.getItem('user'))?.token || '';
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/teachers`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTeachers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/categories`);
      setCategories(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleAddCustomCategory = async () => {
    if (!customCategory.trim()) {
      toast({ title: "Please enter category name", status: "warning", duration: 3000 });
      return;
    }
    try {
      const token = JSON.parse(localStorage.getItem("user"))?.token || "";
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/categories`, {
        name: customCategory.trim()
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast({ title: "Category added successfully", status: "success", duration: 3000 });
      setDetail(prev => ({ ...prev, category: res.data.name }));
      setCustomCategory("");
      setShowCustomInput(false);
      fetchCategories();
    } catch (err) {
      toast({ title: err.response?.data?.message || "Failed to add category", status: "error", duration: 3000 });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetail((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) { // 2MB limit
        toast({ title: "File too large. Max 2MB allowed.", status: "warning" });
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setDetail((prev) => ({ ...prev, img: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async () => {
    try {
      await dispatch(addProduct(detail));
      toast({ title: "Course Added Successfully", status: "success", duration: 2000 });
      navigate("/admin/courses");
    } catch (err) {
      toast({ title: "Error", description: "Error: " + err.message, status: "error" });
    }
  };

  const bgMain = useColorModeValue("var(--background)", "gray.900");
  const cardBg = useColorModeValue("white", "rgba(15, 23, 42, 0.7)");
  const textMain = useColorModeValue("gray.800", "gray.100");
  const cardBorder = useColorModeValue("gray.200", "rgba(255, 255, 255, 0.08)");

  return (
    <Grid className="Nav" h={"99vh"} w="94%" gap={10} bg={bgMain} color={textMain}>
      {/* <AdminSidebar /> */}
      <Box mt='80px'>
        <AdminNavTop />

        <Box border={"1px solid"} borderColor={cardBorder} borderRadius={10} p={10} h="90%" bg={cardBg} boxShadow="sm" maxW="800px" mx="auto">
          <FormControl isRequired>
            <FormLabel>Title</FormLabel>
            <Input
              type="text"
              placeholder="Enter Course Title"
              name="title"
              value={detail.title}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl mt={4} isRequired>
            <FormLabel>Description</FormLabel>
            <Textarea
              placeholder="Enter Course description"
              name="description"
              value={detail.description}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl mt={4} isRequired>
            <FormLabel>Category</FormLabel>
            <Select
              placeholder="Select Course Category"
              name="category"
              value={detail.category}
              onChange={(e) => {
                if (e.target.value === "custom") {
                  setShowCustomInput(true);
                  setDetail(prev => ({ ...prev, category: "" }));
                } else {
                  setShowCustomInput(false);
                  handleChange(e);
                }
              }}
            >
              {categories.map((cat) => (
                <option key={cat._id} value={cat.name}>{cat.name}</option>
              ))}
              <option value="custom">+ Add Custom Category...</option>
            </Select>

            {showCustomInput && (
              <Flex mt={2} gap={2}>
                <Input
                  placeholder="New Category Name"
                  value={customCategory}
                  onChange={(e) => setCustomCategory(e.target.value)}
                />
                <Button colorScheme="green" onClick={handleAddCustomCategory}>Add</Button>
              </Flex>
            )}
          </FormControl>
          <FormControl mt={4} isRequired>
            <FormLabel>Department</FormLabel>
            <Select
              placeholder="Select Department"
              name="department"
              value={detail.department}
              onChange={handleChange}
            >
              {DEPARTMENTS.map((dept) => (
                <option key={dept} value={dept}>{dept}</option>
              ))}
            </Select>
          </FormControl>
          <FormControl mt={4} isRequired>
            <FormLabel>Assign Instructor</FormLabel>
            <Select
              placeholder="Select Instructor"
              name="teacherId"
              value={detail.teacherId || ""}
              onChange={(e) => {
                const selected = teachers.find(t => t._id === e.target.value);
                setDetail(prev => ({
                  ...prev,
                  teacherId: e.target.value,
                  teacher: selected ? selected.fullName : ""
                }));
              }}
            >
              {teachers.map((t) => (
                <option key={t._id} value={t._id}>{t.fullName} ({t.email})</option>
              ))}
            </Select>
          </FormControl>
          <FormControl mt={4} display="flex" alignItems="center">
            <FormLabel mb="0">Enable Discussion & Comments?</FormLabel>
            <Switch
              isChecked={detail.allowComments}
              onChange={(e) => setDetail(prev => ({ ...prev, allowComments: e.target.checked }))}
              colorScheme="purple"
            />
          </FormControl>
          <FormControl mt={4} display="flex" alignItems="center">
            <FormLabel mb="0">Global Training Module (Available to all departments)?</FormLabel>
            <Switch
              isChecked={detail.isGlobal}
              onChange={(e) => setDetail(prev => ({ ...prev, isGlobal: e.target.checked }))}
            />
          </FormControl>

          {!detail.isGlobal && (
            <FormControl mt={4}>
              <FormLabel>Select Target Departments / Sectors</FormLabel>
              <CheckboxGroup
                colorScheme="blue"
                value={detail.targetSectors}
                onChange={(values) => setDetail(prev => ({ ...prev, targetSectors: values }))}
              >
                <Stack spacing={2} direction="row" wrap="wrap">
                  {DEPARTMENTS.map((dept) => (
                    <Checkbox key={dept} value={dept}>{dept}</Checkbox>
                  ))}
                </Stack>

              </CheckboxGroup>
            </FormControl>
          )}
          <FormControl mt={4}>
            <FormLabel>Course Thumbnail (Optional)</FormLabel>
            <Flex gap={4} mb={2}>
              <Button size="sm" variant={uploadType === "link" ? "solid" : "outline"} colorScheme="purple" onClick={() => setUploadType("link")}>Paste Link</Button>
              <Button size="sm" variant={uploadType === "file" ? "solid" : "outline"} colorScheme="purple" onClick={() => setUploadType("file")}>Upload File</Button>
            </Flex>
            {uploadType === "link" ? (
              <Input
                type="text"
                placeholder="Enter Course thumbnail Link (e.g. https://...)"
                name="img"
                value={detail?.img}
                onChange={handleChange}
              />
            ) : (
              <Box border="1px dashed" borderColor="gray.300" p={4} borderRadius="md" textAlign="center">
                <Input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  p={1}
                />
                {detail.img && detail.img.startsWith("data:image") && (
                  <Text mt={2} fontSize="xs" color="green.500">Image selected and ready.</Text>
                )}
              </Box>
            )}
          </FormControl>
          <Button
            mt={8}
            colorScheme="blue"
            size="md"
            w="full"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Grid>
  );
};

export default AddCourse;
